import { api } from './api';

export async function GetRegulamento() {
  const { data } = await api.get('database/regulamento__c?strict=true&q=_id:%2764a69f065ef07b2b978fe2fd%27');
  return data;
}